import { compose } from 'redux';
import { connect } from 'react-redux';
import _ from 'lodash';
import withAuthUser from '../../common/WithAuthUser';
import ListLiveStreamViewer, { Header } from '../../pages/LiveStreamViewer/ListLiveStreamViewer';
import {
    ViewerGetListLiveStreamEventRequested,
    ClearViewerGetListLiveStreamEvent,
    ViewerRegisterLiveStreamRequested,
    ClearViewerRegisterLiveStream,
    ViewerGetListLiveStreamLoginAccRequested,
    ClearViewerGetListLiveStreamLoginAcc,
} from '../../actions/LiveStreamManagement';

const mapStateToProps = (state) => ({
    locale: state.locale.lang.current,
    isLoading: state.livestream.getListLiveStreamViewer.isFetching
        || state.livestream.registerLiveStreamViewer.isFetching
        || state.livestream.getListLivestreamLoginAcc.isFetching
        || state.adminSettingCustom.getCustomText.isFetching,
    listEvent: !state.registration.registrationViewer.data.free_live_stream
                && (!state.auth.credential.data?.isWeakAuth || state.auth.credential.data?.isWeakAuth === 'false')
                && state.auth.credential.isAuthorized ? state.livestream.getListLivestreamLoginAcc.data : state.livestream.getListLiveStreamViewer.data,
    currentPage: !state.registration.registrationViewer.data.free_live_stream
                && (!state.auth.credential.data?.isWeakAuth || state.auth.credential.data?.isWeakAuth === 'false')
                && state.auth.credential.isAuthorized ? state.livestream.getListLivestreamLoginAcc.data.page : state.livestream.getListLiveStreamViewer.data.page,
    totalPage: !state.registration.registrationViewer.data.free_live_stream
                && (!state.auth.credential.data?.isWeakAuth || state.auth.credential.data?.isWeakAuth === 'false')
                && state.auth.credential.isAuthorized ? state.livestream.getListLivestreamLoginAcc.data.total_page : state.livestream.getListLiveStreamViewer.data.total_page,
    listDate: !state.registration.registrationViewer.data.free_live_stream
                && (!state.auth.credential.data?.isWeakAuth || state.auth.credential.data?.isWeakAuth === 'false')
                && state.auth.credential.isAuthorized ? state.livestream.getListLivestreamLoginAcc.listdate : state.livestream.getListLiveStreamViewer.listdate,
    eventInfo: state.registration.registrationViewer.data,
    loggedIn: state.auth.credential.isAuthorized,
    isWeakAuth: state.auth.credential.data?.isWeakAuth,
    isCheckEvent: state.registration.registrationViewer.successInformation,
    registerStatus: state.livestream.registerLiveStreamViewer.registerStatus,
    idRegister: state.livestream.registerLiveStreamViewer.data,
    errorRegister: state.livestream.registerLiveStreamViewer?.data,
    errorRegisterLivestream: state.livestream.registerLiveStreamViewer?.errors,
    customText: state.adminSettingCustom.getCustomText.data?.content,
    customColor: state.registrationOrganizer.registrationOrganizer.data?.settings_colors_viewer,
});

const mapDispatchToProps = (dispatch) => ({
    fetchViewerGetListLiveStream: (event_name) => {
        dispatch(ViewerGetListLiveStreamEventRequested(event_name));
    },
    fetchViewerGetListLiveStreamLoginAcc: (event_name) => {
        dispatch(ViewerGetListLiveStreamLoginAccRequested(event_name));
    },
    fetchViewerClearGetListLiveStream: () => {
        dispatch(ClearViewerGetListLiveStreamEvent());
    },
    viewerRegisterLiveStream: (params) => {
        dispatch(ViewerRegisterLiveStreamRequested(params));
    },
    clearRegisterLiveStream: () => {
        dispatch(ClearViewerRegisterLiveStream());
    },
    ClearViewerGetListLiveStreamLoginAcc: () => {
        dispatch(ClearViewerGetListLiveStreamLoginAcc());
    },
});

export const ListLiveStreamHeader = connect(mapStateToProps, mapDispatchToProps)(Header);

export default compose(
    withAuthUser,
    connect(
        mapStateToProps,
        mapDispatchToProps,
    ),
)(ListLiveStreamViewer);
